var ANIMATION_FALL_BACK_TIME_MS = 300;
var BOTTOM_SHEET_TRANSITION = 'all 0.3s ease-out';
var BOTTOM_SHEET_TITLE_ID = 'Title';
var BOTTOM_SHEET_SUBTITLE_ID_SUFFIX = 'Subtitle';
var BOTTOM_SHEET_CLOSE_KEY = 'Escape';

export { ANIMATION_FALL_BACK_TIME_MS, BOTTOM_SHEET_CLOSE_KEY, BOTTOM_SHEET_SUBTITLE_ID_SUFFIX, BOTTOM_SHEET_TITLE_ID, BOTTOM_SHEET_TRANSITION };
//# sourceMappingURL=constants.js.map
